export const constants = {
  locale: 'th-TH',
  language: 'th',
  languageOptions: ['th', 'en'],

  // datatable
  rowsPerPage: 10,
  rowsPerPageOptions: [10, 20, 30, 40, 50],
  maxPageSize: 5,
  minCurrency: 0,
  minIncome: 1,
  maxCurrency: 9999999999999, // 13 digits
  ageYouth: 15,
  ageMin: 267,
  occupationIdYouth: 1205, // X02-10-10
  occCodeYouth: 'X02-10-10',
  payerYear: 15
};

export const category = {
  OL: 1,
  PA: 2
};

export const type = {
  BASIC: 1,
  RIDER: 2
};

export const factory = {
  selfPackage: 'self_package',
  selfPackageId: 'self_package_id',
  planComparisons: 'plan_comparisons',
  planComparisonsQq: 'plan_comparisons_qq',
  isUWRuleMessage: 'is_uw_rule_message',
  isMessageRiderProduct: 'is_message_rider_product',
  messageCheckingRider: 'message_checking_rider',
  personalId: 'personal_id',
  checkFamilyPlan: 'checkFamilyPlan',
  checkFamilyPlanQq: 'checkFamilyPlanQq',
  prospectCustomerId: 'prospect_customer_id',
  prospectCustomerIdQQ: 'prospect_customer_id_qq',
  personAssuredId: 'person_assured_id',
  personAssuredIdQq: 'person_assured_id_Qq',
  prospectData: 'prospect_data',
  quotationId: 'quotation_id',
  quotationIdQQ: 'quotation_id_QQ',
  quotationNumberQQ: 'quotation_number_QQ',
  quotationNo: 'quotation_no',
  quotationRefer: 'quotationRefer',
  quotationCopy: 'quotation_copy',
  appNoCopy: 'appNo_copy',
  quotationCopyType: 'quotation_copy_type',
  buttonDownload: 'buttonDownload',
  buttonEditQQ: 'buttonEditQQ',
  warningMessage: 'Case monthly must pay 2 Months before !!!!',
  searchQuotation: 'search_quotation',
  quickQuote: 'QQ',
  quotationPage : 'QP',
  quickQuoteChoiceGroupTab: 'QQ_choiceGroup_tab',
  occYouth: null
};
export const screenSize = {
  // Extra small devices (portrait phones, less than 576px)
  'xs': {min: 0, max: 575.99},
  // Small devices (landscape phones, 576px and up)
  'sm': {min: 576, max: 767.99},
  // Medium devices (tablets, 768px and up)
  'md': {min: 768, max: 991.99},
  // Large devices (desktops, 992px and up)
  'lg': {min: 992, max: 1199.99},
  // Extra large devices (large desktops, 1200px and up)
  'xl': {min: 1200, max: 7200},
};

export const messageAlert = [
  '- การสร้างใบเสนอราคาสำหรับ 20LPPA',
  '- การแก้ไขข้อมูลลูกค้าเมื่อออก Quotation ไปแล้ว',
  '- การ Copy Quotation เพื่อสร้างใบเสนอราคาใหม่',
  '- การใช้งาน Menu Self-Defined Package'
];
